import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import classNames from 'classnames';
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Parts} from "components";
import CollectionOverride from "components/CollectionOverride";
import {Elements} from "../index";
import {confirmAlert} from "react-confirm-alert";
import products from "../../routes/app/routes/products";
import Select from "react-select";
import APPCONFIG from "../../constants/Config";

class DavidsonsProducts extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Davidsons_Products._name, API.RequestType.READ_ALL);
		super(props, model);

		this.state.caliber = '';
		this.state.caliber_error = '';
		this.state.calibers = null;
		this.state.manufacturer = '';
		this.state.manufacturer_error = '';
		this.state.manufacturers = null;
		this.state.type = '';
		this.state.type_error = '';
		this.state.types = null;
		this.state.products = [];
		this.state.location = '';
		this.state.location_error = '';
	}

	customStyles = {
		menu: (provided) => ({
			...provided, zIndex: 9999
		})
	};

	clearFilters = () => {
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			startDate: '',
			endDate: '',
			filterLocation: null,
			filterStatus: null,
			filterUsed: null,

			caliber: '',
			calibers: null,
			manufacturer: '',
			manufacturers: null,
			type: '',
			types: null,
		});
		let path = window.location.pathname.replaceAll('/', ' ').titleCase().replaceAll(' ', '');
		localStorage.removeItem('table-preferences-' + path);
	}

	componentDidMount() {
		super.componentDidMount();
		if(this.props.rootState.davidsons_account_number === "" || this.props.rootState.davidsons_account_number === 'undefined'){
			//pop confirmation here
			confirmAlert({
				title: "Davidson's Account",
				message: 'You need to put in your davidson account information',
				buttons: [
					{
						label: 'Go To Account Settings',
						color: 'danger',
						onClick: async () => {
							this.props.history.push('/accounts');
						}
					}
				],
				closeOnEscape: false,
				closeOnClickOutside: false,
			});
		}
	}

	addItemNumber = (e) => {
		const {data, products} = this.state;
		const id = parseInt(e.currentTarget.id);
		let found = products.find((entry) => entry.pkey === id);

		if (!found) {
			const product = data.find((entry) => entry.pkey === id)

			if (product) {
				products.push(product);

				this.setState({
					products,
					products_error: ""
				});
			}
		} else {
			this.setState({
				products_error: "Product already in list.",
			});
		}
	};

	updateItemQuantity = (pkey, item, quantity) => {
		this.state.products.map((product, ndx) => {
			if (item === product.item) {
				this.state.products[ndx].item_quantity = quantity;
			}
		})

		this.setState({key: Math.random()})
	}

	updateItemQuantityValue = (index, inventory, pkey) => event => {
		const re = /^[0-9\b]+$/;
		// if value is not blank, then test the regex
		if (event.currentTarget.value === '' || (event.currentTarget.value !== '0' && re.test(event.currentTarget.value))) {
			let items = this.state.products;
			items[index].item_quantity = event.currentTarget.value !== '' ? parseFloat(event.currentTarget.value) : '';
			// this.setState({items: items});
			if (items[index].item_quantity !== "" && items[index].item_quantity !== 0) {
				this.updateItemQuantity(pkey, inventory, event.currentTarget.value);
			}
		}
	};

	removeItemNumber = (e) => {
		const {products} = this.state;
		const item = e.currentTarget.id;
		// const binary_id = e.currentTarget.getAttribute('binary_id');
		const existingProductIndex = products.findIndex((entry) => entry.item == item);

		if (existingProductIndex > -1) {
			products.splice(existingProductIndex, 1);
		}

		this.setState({
			products,
			products_error: '',
		});
	};

	submitDavidsons = async () => {
		this.setState({loading: true});
		let upcString = '';
		let quantity = 0;
		this.state.products.map((product) => {
			upcString += product.upc_code + ',' + product.item_quantity + '|';
			quantity += parseInt(product.item_quantity);
		})
		let dModel = new API.BuildClass(Types.Davidsons_Pendings._name, API.RequestType.CREATE);
		dModel.object.upcs = upcString;
		dModel.object.ffl_name = 'DAVIDSON\'S';
		dModel.object.location = this.state.location;
		dModel.object.account = this.state.locations.account;
		dModel.object.quantity_products = quantity;
		dModel.object.location_binary_id = this.state.location_binary_id;
		try {
			let result = await dModel.submit(null, API.RequestType.CREATE);
		} catch (e) {
			console.error(e);
		}
		this.setState({loading: false});
		this.props.history.push('/acquisitions/pendings#processing')
	}

	addProducts = async () => {
		const myProducts = this.state.products;
		let sum = [...this.state.products].reduce((acc, x) => acc + parseFloat(x.min_price * x.item_quantity), 0);
		sum.toFixed(2);
		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert" style={{overflow: "scroll", maxHeight: "800px"}}>
						<div className="react-confirm-alert-body" style={{maxWidth: '100%', width: '800px'}}>
							<h1 dangerouslySetInnerHTML={{__html: 'Confirm Transfer'}} style={{textAlign: 'center'}}/>
							<hr style={{height: '3px', border: 'none', color: 'rgb(60,90,180)', 'background-color': 'rgb(60,90,180)'}}/>
							<h3 dangerouslySetInnerHTML={{__html: `Are you sure you want to add this transfer from Davidson's to ${this.state.locations.name_display}`}}/>
							{this.state.products.map(product =>
								<div style={{textAlign: 'left'}}>
									<span style={{textAlign: "left", fontSize: '16px'}}>
										{product.item}:
									</span>
									<span style={{textAlign: "center", fontSize: '16px', 'font-weight': 'bold'}}>
										&ensp; ${product.min_price * parseInt(product.item_quantity)} ({product.min_price} * {product.item_quantity})
									</span>
								</div>
							)}
							<br></br>
							<div style={{textAlign: "center", fontSize: '20px', 'font-weight': 'bold'}}>
								Total Price: ${parseFloat(sum).toFixed(2)}
							</div>
							<div className="react-confirm-alert-button-group">
								<div style={{display: 'flex', width: '100%'}}>
									<button onClick={() => {
										onClose();
									}} style={{textAlign: 'right'}} className={'btn btn-danger'}>
										Cancel
									</button>
								</div>
								<div style={{display: 'flex', width: '100%', justifyContent: 'flex-end'}}>
									<button onClick={() => {
										this.submitDavidsons();
										onClose();
									}} style={{alignSelf: 'left'}} className={'btn btn-primary'}>
										Submit Transfer
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});
	};

	handleMySelectPropertyUpdate = (property, value, linked, object) => {
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				this.setState({
					[linked]: object,
					[property]: value,
					[property + '_error']: '',
					[property + '_binary_id']: object.binary_id,
					[property + '_binary_id_error']: '',
				});
			} else {
				if (this.state.hasOwnProperty(property + '_binary_id')) {
					this.setState({
						[linked]: object,
						[property]: value,
						[property + '_error']: '',
						[property + '_binary_id']: null,
						[property + '_binary_id_error']: '',
					});
				} else {
					this.setState({
						[linked]: object,
						[property]: value,
						[property + '_error']: '',
					});
				}
			}
		} else {
			if (this.state.hasOwnProperty(property + '_binary_id')) {
				this.setState({
					[property]: value,
					[property + '_error']: '',
					[property + '_binary_id']: null,
					[property + '_binary_id_error']: '',
				});
			} else {
				this.setState({
					[property]: value,
					[property + '_error']: '',
				});
			}
		}
	};

	render() {
		const {data, pages, limit, loading, columnsAnchor} = this.state;
		const columns = [
			{
				Header: "ID",
				id: "pkey",
				Cell: props => {
					return (
						<span>
							<a href={`https://www.galleryofguns.com/genie/default.aspx?item=${props.original.item}`}
							   target={'_blank'}>
								{props.original.item}
							</a>
						</span>
					);
				}
			},
			{
				Header: "Product Class",
				accessor: "product_class",
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Davidsons_Products_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other ? obj.manufacturer_other : '')
			},
			{
				Header: "Caliber",
				id: 'caliber',
				/** @param {Davidsons_Products_Object} obj */
				accessor: obj => (obj.calibers ? obj.calibers.name : obj.caliber_other)
			},
			{
				Header: "Model",
				accessor: 'model',
			},
			// {
			// 	Header: "Mag Capacity",
			// 	accessor: "mag_capacity",
			// },
			{
				Header: "Quantity",
				accessor: "quantity",
			},

			{
				Header: "UPC",
				accessor: "upc_code",
			},
			{
				Header: 'Price',
				id: 'min_price',
				/** @param {Davidsons_Products_Object} obj */
				accessor: obj => <div>${obj.min_price}</div>
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				// show: !!this.props.hasModal,
				Cell: props => {
					return (
						<Button
							id={props.original.pkey}
							binary_id={props.original.binary_id}
							data-id={"product-" + props.original.serial_number}
							color="blue-hoki"
							size={"sm"}
							block={true}
							onClick={this.addItemNumber}>
							<i className={"fa fa-plus"}/>
						</Button>
					);
				}
			},
		];
		/** @type {Davidsons_Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Davidsons_Products_Object} object */
		let object = this.state;
		return (
			<div>
				<div className={"row"}>
					<div className={"col-md-8"}>
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Davidsons Products', "")}
								{/*{this.renderLocationFilter()}*/}
								{/*<div className="col-8">*/}

								<div className="statusFilter">
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.status != null && this.state.filter.status.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterStatus}
										isClearable={true}
										isSearchable={true}
										name="product_class"
										placeholder={"Product Class..."}
										options={[
											{value: null, label: 'All'},
											{value: 'Accessory', label: 'Accessory'},
											{value: 'Ground Shipping Only', label: 'Ground Shipping Only'},
											{value: 'Handgun', label: 'Handgun'},
											{value: 'Long Gun', label: 'Long Gun'},
											{value: 'Magazine', label: 'Magazine'},
										]}
									/>
								</div>

								{this.renderHeaderRight("Products", columns, columnsAnchor, this.handleOpen, this.handleClose)}
								{/*</div>*/}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
							renderPageSizeOptions={this.renderPageSizes}
							pageSize={limit}
							className="-striped -highlight"
						/>

					</div>
					<div className={"col-md-4"}>
						<h4 className="section-title">Transfer Location</h4>
						<div className="StatusFilter">
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={true}
								onSelectUpdate={this.handleMySelectPropertyUpdate}
								// model={Types.Locations._name}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
								disabled={false}
								hideLabel={true}
							/>
						</div>
						<h4 className="section-title">Selected Product(s)</h4>
						<div style={{"maxHeight": "633px", "overflowY": "scroll", "paddingRight": "4px"}}>
							{this.state.products_error &&
								<div style={{
									"padding": "0px 4px 4px",
									"fontStyle": "italic",
									"fontSize": "12px",
									"color": "#ef534f",
									"textAlign": "center"
								}}>
									{this.state.products_error}
								</div>
							}
							{this.state.importListError &&
								<div style={{
									"padding": "0px 4px 4px",
									"fontStyle": "italic",
									"fontSize": "12px",
									"color": "#ef534f",
									"textAlign": "center"
								}}>
									{this.state.importListError}
								</div>
							}
							{this.state.products.map((product, item) => {
								return (
									<Elements.DavidsonsItemLookup
										key={item}
										product={product}
										itemKey={item}
										remove={this.removeItemNumber}
										update={this.updateItemQuantity}
										updateQ={this.updateItemQuantityValue}/>
								);
							})}
						</div>
						{this.state.products.length > 0 && <Button
							onClick={this.addProducts}
							color={"primary"}
							size={"md"}
						>Add Transfer</Button>}
						{/*#endregion*/}
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</div>
			</div>
		)
	}
}
export default Framework.Components.withRootState(DavidsonsProducts);
